import { useAxios } from '../utils/axiosConfig';
import { useNotification } from "../contexts/NotificationContext";
import config from '../contexts/ConfigContext';
import { AuditEntriesModel } from 'components/History Tracking/AuditComponent';

export interface FilterModel {
    Tags: string[];
    WhereType: number;
}

export interface RoleModel {
    ProjectId: number;
    TargetId: number;
    ObjectIds: number[];
}

export interface RolePermissionModel {
    PermissionId: number;
    RoleId: number;   
    CanCreate: boolean;
    CanEdit: boolean;
}

export class RoleService {

    axios = useAxios();

    // Define the notification hook
    notification = useNotification();

    // Call the API to get the filters for the current user and project
    async GetMyProjectRolesFilter(): Promise<FilterModel> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/ProjectRoles/GetMyFilter`);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching filters: ' + error, 'error');
            console.error('Error fetching filters:', error);
            return { Tags: [], WhereType: 1 };
        }
    }
    // Call the API to update the filters for the current user and project
    async UpdateMyProjectRolesFilter(filterModel: FilterModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectRoles/UpdateMyFilter`, filterModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching roles: ' + error, 'error');
            console.error('Error fetching roles:', error);
            
        }
    }

    // Call the API to add roles to the current project
    async AddRolesToProject(roleModel: RoleModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectRoles/AddRoleToProject`, roleModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error add roles: ' + error, 'error');
            console.error('Error add roles:', error);
           
        }
    }

    // Call the API to remove roles from the current project
    async RemoveRolesFromProject(roleModel: RoleModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectRoles/RemoveRoleFromProject`, roleModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error remove roles: ' + error, 'error');
            console.error('Error remove roles:', error);
           
        }
    }

    // Call the API to add users to the current role
    async AddUsersToRole(roleModel: RoleModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectRoleUsers/AddUserToRole`, roleModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error add users: ' + error, 'error');
            console.error('Error add users:', error);
            
        }
    }

    // Call the API to remove users from the current role
    async RemoveUsersFromRole(roleModel: RoleModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectRoleUsers/RemoveUserFromRole`, roleModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error remove users: ' + error, 'error');
            console.error('Error remove users:', error);
            
        }
    }

    // Call the API to add permissions to the current role
    async AddPermissionsToRole(roleModel: RoleModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectRolePermissions/AddPermissionToRole`, roleModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error add permissions: ' + error, 'error');
            console.error('Error add permissions:', error);
            
        }
    }

    // Call the API to remove permissions from the current role
    async RemovePermissionsFromRole(roleModel: RoleModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectRolePermissions/RemovePermissionFromRole`, roleModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error remove permissions: ' + error, 'error');
            console.error('Error remove permissions:', error);
            
        }
    }

     // Call the API to update permission for the current role
     async UpdatePermissionForRole(roleModel: RolePermissionModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectRolePermissions/UpdatePermissionForRole`, roleModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error update permission: ' + error, 'error');
            console.error('Error update permission:', error);
            
        }
    }

    // Call the API to get the filters for the current user and project
    async GetMyRolesFilter(): Promise<FilterModel> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/Roles/GetMyFilter`);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching filters: ' + error, 'error');
            console.error('Error fetching filters:', error);
            return { Tags: [], WhereType: 1 };            
        }
    }

    // Call the API to update the filters for the current user and project
    async UpdateMyRolesFilter(filterModel: FilterModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/Roles/UpdateMyFilter`, filterModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching roles: ' + error, 'error');
            console.error('Error fetching roles:', error);
           
        }
    }

    async GetAudit(roleId: number): Promise<AuditEntriesModel[]>{
        try {
            const response = await this.axios.get(config.API_URL + "/api/Roles/GetAudit?roleId=" + roleId);
            return response.data;
        }
        catch (error: any) {
            this.notification.showNotification("Error getting role audit history: " + error, 'error');
            console.error("Error getting role audit history: ", error);
            return {} as AuditEntriesModel[];
        }
    }

}